var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('CorpForm',{attrs:{"corpId":_vm.corpId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }